import dayjs from "dayjs";
import { backendDateFormat } from "tm-shared/constants";

import { KPI_DELAY_DAYS } from "@/config";

export function getKpiTargetDate(): string {
    const today = dayjs().startOf("day");

    // якщо delay = 0, то одразу беремо поточну дату
    if (KPI_DELAY_DAYS <= 0) {
        return today.format(backendDateFormat.date);
    }

    const currentDay = today.date();

    // якщо від початку місяця пройшло більше днів, ніж delay
    // то показуємо KPI за поточний місяць
    if (currentDay > KPI_DELAY_DAYS) {
        return today.format(backendDateFormat.date);
    }

    // інакше ще показуємо KPI за минулий місяць
    return today
        .subtract(1, "month")
        .endOf("month")
        .startOf("day")
        .format(backendDateFormat.date);
}
